export default "__VITE_ASSET__ClxSMh3K__"